import { get, set } from 'idb-keyval';

export { dbNames } from './utils';

type requestType = 'GET' | 'POST' | 'PATCH' | 'DELETE';

export type Payload = {
  [key: string]: string | number | boolean | object | null;
};

export const isLocalHost = process.env.NODE_ENV !== 'production';

interface Config {
  getNumber(name: string): number;
  getString(name: string): string;
}

export function getHostUrl(): string {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname === 'localhost'
      ? 'http://localhost:7007'
      : `https://${hostname}`;
  }

  // Fallback for Node
  return 'http://localhost:7007';
}
export const hostUrl = getHostUrl();

export function removeSpecialCharacters(data: string) {
  const harmfulCharacters = /'|"|;|\\/g; // No @ts-expect-error needed here
  const sanitizedName = data.replace(harmfulCharacters, '');
  let escapedName = sanitizedName.replace(/&/g, '&amp;');
  escapedName = escapedName.replace(/</g, '&lt;');
  escapedName = escapedName.replace(/>/g, '&gt;');
  let doubleEscapedName = escapedName.replace(/&amp;/g, '&amp;amp;');
  doubleEscapedName = doubleEscapedName.replace(/&lt;/g, '&amp;lt;');
  doubleEscapedName = doubleEscapedName.replace(/&gt;/g, '&amp;gt;');
  doubleEscapedName = doubleEscapedName.replace(/>/g, '&gt;');
  doubleEscapedName = doubleEscapedName.replace(/"/g, '&quot;');
  doubleEscapedName = doubleEscapedName.replace(/'/g, '&apos;');
  doubleEscapedName = doubleEscapedName.replace(/&lt;/g, '<');
  doubleEscapedName = doubleEscapedName.replace(/&gt;/g, '>');
  doubleEscapedName = doubleEscapedName.replace(/</g, '&lt;');
  doubleEscapedName = doubleEscapedName.replace(/>/g, '&gt;');
  doubleEscapedName = doubleEscapedName.replace(/"/g, '&quot;');
  doubleEscapedName = doubleEscapedName.replace(/'/g, '&apos;');
  doubleEscapedName = doubleEscapedName.replace(/&amp;/g, '&');
  return doubleEscapedName;
}

export const urls = {
  yamlValidator: `api/catalog-customizations/validator?url=`,
  systemsByGroup: `api/catalog-customizations/systemsByGroup?name=`,
  getAllSystems: `api/catalog-customizations/getAllSystems`,
  getComponentByServiceName: `api/catalog-customizations/getComponentByServiceName?name=`,
  getSystemByServiceName: `api/catalog-customizations/getSystemByServiceName?name=`,
  previewMarkDown: `api/catalog-customizations/markdownPreview?url=`,
  // getAdrList: `api/adr/list?url=`,
  // getAdrContentByName: `api/adr/file?url=`,
  getAdrList: `api/catalog-customizations/getFilesFromDirectoryByUrl?url=`,
  getAdrContentByName: `api/catalog-customizations/getFileContentByUrl?url=`,
  getBase64Image: `api/catalog-customizations/getBase64Image?url=`,
  isAzureProjectExists: `api/catalog-customizations/checkIfProjectExists?name=`,
  getPipelineDataByTemplateName: `api/catalog-customizations/getPipelineParamsByName?name=`,
  prepareGardRailsData: `api/techdocs/sync/default/domain/cop_dso`,
  getGuardRailsData: `api/techdocs/static/docs/default/domain/cop_dso/index.html`,
  getAllAdrs: `api/catalog-customizations/getAllAdrs`,
  getEpicAvatarArr: `api/catalog-customizations/getAvatarByName?name=`,
  getDevSecOpsEpics: `api/catalog-customizations/getEpics`,
  getOwnershipCount: `api/catalog-customizations/getOwnershipCount?name=`,
  getContributorsByTeam: `api/catalog/entities/by-name/group/default/`,
  getGroupInfoByTeam: `api/catalog/entities/by-name/groupinfo/default/`,
  getTeamsDataById: `api/catalog/entities/by-name/domain/default/`,
  getConfigByName: `api/catalog-customizations/getConfigByName?name=`,
  getMultiAdrList: `api/catalog-customizations/getFilesFromDirectoryByUrl?url=`,
  getPdfFile: `api/catalog-customizations/getPdfFile?url=`,
  getAllProcessedOwners: `api/catalog-customizations/getAllProcessedOwners`,
  getTrackSpaceUser: `api/catalog-customizations/getTrackSpaceUser?user=`,
  getCreatedTrackSpaceId: `api/catalog-customizations/getCreatedTrackSpaceId?id=`,
  getPiplineStatusByTasKId: `api/catalog-customizations/getPipelineStatus?id=`,
  getAllUsers: `api/catalog-customizations/getAllUsers`,
  getAzureLogsById: `api/catalog-customizations/getAzureLogsById?logId=`,
  runComponentAzurePipelineStatus: `api/catalog-customizations/runComponentAzureDevOps?token=`,
  getFolderPath: `api/catalog-customizations/getFolderPathByName`,
  getLanguageById: `api/catalog-customizations/getLinguistByURl?id=`,
  checkIfGroupExists: `api/catalog-customizations/checkIfGroupExists?id=`,
  oIPJsonValidateEndpoint: `https://openapi-validator.api-dev.lhgroup.de/api/v1/validate`,
  checkmarxScanResultByProject: `api/catalog-customizations/SastReportByProjectName?projectName=`,
  checkmarxgetApplicationByTag: `api/catalog-customizations/getAllCheckMarxApplications`,
  sonarQubeMeasuresByProjects: `api/catalog-customizations/sonarQubeMeasuresByProjects`,
  sonarQubeLinesByProject: `api/catalog-customizations/sonarQubeLinesByProject?projectKey=`,
  getAllCustomGroupInfo: `api/catalog-customizations/getAllCustomGroupInfo`,
  getProductDetailsById: `api/catalog/entities/by-name/system/default/`,
  getProcessedProducts: `api/catalog-customizations/getAllProcessedproducts`,
  getComponentDetailsId: `api/catalog/entities/by-name/component/default/`,
  getTeamDataByTeamName: `api/catalog/entities/by-name/group/default/`,
  getUserDetailsById: `api/catalog/entities/by-name/user/default/`,
  getGroupInfoDataByTeamName: `api/catalog/entities/by-name/groupinfo/default/`,
  getEntraIdDetailsByName: `api/catalog-customizations/getEntraIdDetailsByName`,
  getGuardRailReportByTeamName: `api/catalog-customizations/getGuardRailReportByTeamName?team=`,
  getHierachyList: `api/catalog-customizations/getHierachy`,
  getMembersByTeam: `api/catalog-customizations/getMembersByTeam?team=`,
  joinProject: `api/catalog-customizations/joinProject`,
  leaveBazaarProject: `api/catalog-customizations/leaveBazaarProject`,
  fetchDocNameByGroupName: `api/catalog-customizations/fetchDocNameByGroupName?groupName=`,
  getAllProjectsCount: `api/catalog-customizations/getAllProjectsCount`,
  getAllFeedBackResponses: `api/catalog-customizations/getAllFeedbacks`,
  getConfigContext: `api/catalog-customizations/configContext`,
  saveGeneratedKey: `api/catalog-customizations/saveUserPublicKey`,
  getEntraIdGroupList: `api/catalog-customizations/getEntraIdGroups`,
  getFileCountInDir: `api/catalog-customizations/getFileCountInDir?url=`,
  generateUserPat: `api/catalog-customizations/generateUserToken`,
  getPATByEmail: `api/catalog-customizations/getPATByEmail`,
  deletePAT: `api/catalog-customizations/deletePAT`,
  // DAP Feature Flags
  getTeams: `api/dap/teams`,
  createTeams: `api/dap/teams`,
  updateTeam: `api/dap/teams`,
  deleteTeam: `api/dap/teams/`,
  getTeamConfig: `api/dap/config/`,
  setConfig: `api/dap/config/`,
};

export const getEnv = (config: Config, name: string) => {
  const envtoken = config.getString(name);
  return envtoken;
};

export const getEnvNumber = (config: Config, name: string) => {
  const env_token = config.getNumber(name);
  return env_token;
};

const requestHeader = (
  type: requestType,
  payload?: Payload,
  token?: string,
) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const requestConfig: RequestInit = {
    method: type,
    headers,
  };

  if ((type === 'POST' || type === 'PATCH') && payload) {
    requestConfig.body = JSON.stringify(payload);
  }

  return requestConfig;
};

export async function fetchData(
  url: string,
  payload?: Payload,
  isPatch?: boolean,
  isDelete?: boolean,
): Promise<any> {
  try {
    let methodType: requestType = 'GET';

    if (!payload) {
      methodType = 'GET';
    } else if (isPatch) {
      methodType = 'PATCH';
    } else if (isDelete) {
      methodType = 'DELETE';
    } else {
      methodType = 'POST';
    }

    const store = (window as any).dhDockStore;
    const identity = store?.getState()?.auth?.identity;
    let token = store?.getState()?.auth?.token || '';

    if (identity) {
      const creds = await identity.getCredentials();
      token = creds?.token || token;
    }

    // First attempt with existing token
    let responseContent = await fetch(
      `${hostUrl}/${url}`,
      requestHeader(methodType, payload, token),
    );

    if (responseContent.status === 401 && identity) {
      const creds = await identity.getCredentials();
      token = creds?.token || '';

      responseContent = await fetch(
        `${hostUrl}/${url}`,
        requestHeader(methodType, payload, token),
      );
    }

    const contentType = responseContent.headers.get('Content-Type');

    let resolvedContent;

    if (contentType) {
      if (contentType.includes('application/json')) {
        resolvedContent = await responseContent.json();
      } else if (contentType.includes('application/pdf')) {
        resolvedContent = await responseContent.blob();
      } else {
        resolvedContent = await responseContent.text();
      }
    }

    if (responseContent.ok) {
      if (contentType?.includes('application/pdf')) {
        return URL.createObjectURL(resolvedContent);
      }
      return resolvedContent;
    }

    const statusDescription = [
      responseContent.status,
      responseContent.statusText,
    ]
      .filter(Boolean)
      .join(' ');
    throw new Error(`Request failed with status ${statusDescription}`);
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }

    throw new Error(
      typeof error === 'string' && error
        ? error
        : 'Request failed with an unknown error',
    );
  }
}

const allowedCustomizedUrlConfigs = {
  techradar: 'newtechRadar.location',
  entraidPeopleAppTeamsLocation: 'entraidPeopleAppTeamsLocation',
  guidelinesLocation: 'guidelinesLocation',
  techradarReadMe: 'newtechRadar.readme',
};

export const allowedCustomizedConfigs = [
  ...Object.values(allowedCustomizedUrlConfigs),
];

export async function generateKeyPair(KEY_NAME: string) {
  // Generate temporary extractable key pair
  const generatedKeyPair = (await crypto.subtle.generateKey(
    {
      name: 'RSA-OAEP',
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: 'SHA-256',
    },
    true,
    ['encrypt', 'decrypt'],
  )) as CryptoKeyPair;

  // Export private key
  const privateKeyPkcs8 = await crypto.subtle.exportKey(
    'pkcs8',
    generatedKeyPair.privateKey,
  );

  // Export public key
  const publicKeySpki = await crypto.subtle.exportKey(
    'spki',
    generatedKeyPair.publicKey,
  );

  // Re-import private key as NON extractable
  const privateKey = await crypto.subtle.importKey(
    'pkcs8',
    privateKeyPkcs8,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256',
    },
    false, // 🔒 private key cannot be exported
    ['decrypt'],
  );

  // Re-import public key as extractable
  const publicKey = await crypto.subtle.importKey(
    'spki',
    publicKeySpki,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256',
    },
    true, // public key can be exported
    ['encrypt'],
  );

  const keyPair: CryptoKeyPair = {
    publicKey,
    privateKey,
  };

  await set(KEY_NAME, keyPair);

  return keyPair;
}

export async function loadOrCreateKeyPair(email: string) {
  const KEY_NAME = `${isLocalHost ? 'dev-' : 'production-'}dh-dock-rsa_key_${email}`;

  const existing = await get(KEY_NAME);

  if (existing) {
    return existing as CryptoKeyPair;
  }

  return generateKeyPair(KEY_NAME);
}

export async function exportPublicKeyBase64(publicKey: CryptoKey) {
  const spki = await crypto.subtle.exportKey('spki', publicKey);

  const bytes = new Uint8Array(spki);

  let binary = '';

  bytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary);
}

export async function getPrivateKeyByEmail(email: string): Promise<CryptoKey> {
  const keyPair = await loadOrCreateKeyPair(email);

  if (!keyPair?.privateKey) {
    throw new Error('Private key not found');
  }

  return keyPair.privateKey;
}

export async function decryptAllFilesList(items: any[], privateKey: CryptoKey) {
  const results = await Promise.allSettled(
    (items ?? []).map(item => decryptFile(item, privateKey)),
  );

  return results
    .filter(
      (result): result is PromiseFulfilledResult<any> =>
        result.status === 'fulfilled',
    )
    .map(result => result.value)
    .filter(Boolean);
}

async function decryptField(
  field: { wrappedKey: string; ciphertext: string; iv: string; tag?: string },
  privateKey: CryptoKey,
): Promise<string> {
  const wrappedKeyBytes = Uint8Array.from(atob(field.wrappedKey), c =>
    c.charCodeAt(0),
  );
  const ciphertextBytes = Uint8Array.from(atob(field.ciphertext), c =>
    c.charCodeAt(0),
  );
  const ivBytes = Uint8Array.from(atob(field.iv), c => c.charCodeAt(0));
  const tagBytes = field.tag
    ? Uint8Array.from(atob(field.tag), c => c.charCodeAt(0))
    : new Uint8Array();

  // Unwrap AES key
  const aesKeyRaw = await crypto.subtle.decrypt(
    { name: 'RSA-OAEP' },
    privateKey,
    wrappedKeyBytes,
  );
  const aesKey = await crypto.subtle.importKey(
    'raw',
    aesKeyRaw,
    { name: 'AES-GCM' },
    false,
    ['decrypt'],
  );

  // Combine ciphertext + tag if present
  const combined = new Uint8Array(ciphertextBytes.length + tagBytes.length);
  combined.set(ciphertextBytes, 0);
  combined.set(tagBytes, ciphertextBytes.length);

  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: ivBytes },
    aesKey,
    combined,
  );

  return new TextDecoder().decode(decrypted);
}

async function decryptFile(item: any, privateKey: CryptoKey) {
  try {
    const tasks = {
      title: item.title
        ? decryptField(item.title, privateKey)
        : Promise.resolve(''),
      status: item.status
        ? decryptField(item.status, privateKey)
        : Promise.resolve(''),
      date: item.date
        ? decryptField(item.date, privateKey)
        : Promise.resolve(''),
      path: item.path
        ? decryptField(item.path, privateKey)
        : Promise.resolve(''),
      name: item.name
        ? decryptField(item.name, privateKey)
        : Promise.resolve(''),
      initialUrl: item.initialUrl
        ? decryptField(item.initialUrl, privateKey)
        : Promise.resolve(''),
      initialTreeRelativePath: item.initialTreeRelativePath
        ? decryptField(item.initialTreeRelativePath, privateKey)
        : Promise.resolve(''),
      tag: item.tag ? decryptField(item.tag, privateKey) : Promise.resolve(''),
      content: item.content
        ? Promise.all(
            item.content.map((line: any) => decryptField(line, privateKey)),
          )
        : Promise.resolve([]),
    };

    const results = await Promise.all(Object.values(tasks));

    return {
      title: results[0] as string,
      status: results[1] as string,
      date: results[2] as string,
      path: results[3] as string,
      name: results[4] as string,
      initialUrl: results[5] as string,
      initialTreeRelativePath: results[6] as string,
      tag: results[7] as string,
      content: results[8],
    };
  } catch (error) {
    throw new Error('Failed to decrypt file');
  }
}

if (typeof window !== 'undefined') {
  (window as any).fetchData = fetchData;
  (window as any).urls = urls;
}
